









import {Component, Vue} from "vue-property-decorator";
import IntroducingCard from "@/components/landing/IntroducingCard.vue";
import intro1 from "@/assets/images/intro1.svg";
import intro2 from "@/assets/images/intro2.svg";
import intro3 from "@/assets/images/intro3.svg";
import intro4 from "@/assets/images/intro4.svg";
import {Card} from "@/types/landing/Card";
@Component({
  components: {IntroducingCard},
})
export default class Introducing extends Vue {
  cards: Card[] = [
    {
      imgSrc: intro1,
      title: "操作簡單",
      description: "Real-Shopper 已整合各大電商平台，現在只需進行簡單 2 個步驟，即可立即加入提升品牌成效。",
    },
    {
      imgSrc: intro2,
      title: "專業服務",
      description: "Real-Shopper 擁有 Google 專業認證，並且服務超過 30+ 知名品牌獲得顯著銷售成長。",
    },
    {imgSrc: intro3, title: "透視轉換", description: "觸及更多消費者並在各大電商平台透視及創造亮眼的轉換成效。"},
    {
      imgSrc: intro4,
      title: "成效報表",
      description: "提供線上即時報表隨時了解各成效執行指標。",
    },
  ];
}
